var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2919 3.66729C32.9001 2.22302 31.7498 1.08804 30.286 0.701425C27.6327 0 17 0 17 0C17 0 6.3673 0 3.71683 0.701425C2.25305 1.08804 1.10273 2.22302 0.710899 3.66729C0 6.28245 0 11.742 0 11.742C0 11.742 0 17.2015 0.710899 19.8166C1.10273 21.2609 2.25305 22.3959 3.71683 22.7825C6.3673 23.4839 17 23.4839 17 23.4839C17 23.4839 27.6327 23.4839 30.2832 22.7825C31.747 22.3959 32.8973 21.2609 33.2891 19.8166C34 17.2015 34 11.742 34 11.742C34 11.742 34 6.28245 33.2891 3.66729H33.2919ZM13.5994 16.7735V6.71049L22.4325 11.742L13.5994 16.7735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhiteLogo);
export default __webpack_public_path__ + "static/media/youtube-white-logo.1300d68ae80d94137fac0e34b2bb149b.svg";
export { ForwardRef as ReactComponent };